import { useQuery } from '@tanstack/react-query'
import {
  isUserAdminInSociety,
  isUserBoardMemberInSociety,
} from '../../helpers/society'
import { ISocietiesModel } from '../../interfaces/models/societies.interfaces'
import { societyQueries } from '../../api/societies'

interface useUserFeedSocietiesProps {
  userId: string
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useUserFeedSocieties = ({ userId }: useUserFeedSocietiesProps) => {
  const { data: societies, ...rest } = useQuery(
    societyQueries.getUserSocieties(userId)
  )

  const filteredSocieties = societies?.filter(
    (_society) =>
      _society.residentPostingDisabledByAdmin === false ||
      isUserBoardMemberInSociety(_society, userId as string) ||
      isUserAdminInSociety(_society, userId as string)
  )

  return {
    societies: filteredSocieties || [],
    ...rest,
  }
}

export const getSocietiesWhereUserCanPost = ({
  userId,
  societies,
}: {
  userId: string
  societies: ISocietiesModel[]
}): ISocietiesModel[] => {
  return societies.filter(
    (_society) =>
      _society.residentPostingDisabledByAdmin === false ||
      isUserBoardMemberInSociety(_society, userId as string) ||
      isUserAdminInSociety(_society, userId as string)
  )
}
